/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import _ from "lodash";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { useShelfId } from "../provider";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_BOXES } from "../graphql";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetBoxesMethods extends IPluginMethodMap {
    getBoxes(args: any): Promise<any>;
}

export class GetBoxesService implements IAgentPlugin {
    readonly methods: IGetBoxesMethods;

    constructor() {
        this.methods = {
            getBoxes: this.getBoxes.bind(this),
        };
    }

    async getBoxes(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        const { shelfId } = useShelfId();
        let filters = {};
        filters = { shelf__in: [shelfId] }
        console.log("args?.criteriaargs?.criteria", pretty(args?.criteria))
        if (args?.criteria?.user___fullName__contains_i) {
            filters = {
                ...filters,
                user___fullName__contains_i:
                    args?.criteria?.user___fullName__contains_i
            }
        }
        if (args?.criteria?.user___email__contains_i) {
            filters = {
                ...filters,
                user___email__contains_i:
                    args?.criteria?.user___email__contains_i
            }
        }
        if (args?.criteria?.masqID__in) {
            filters = {
                ...filters,
                masqID__in:
                    [args?.criteria?.masqID__in]
            }
        }
        if (args?.criteria?.costumeID__in) {
            filters = {
                ...filters,
                costumeID__in:
                    [args?.criteria?.costumeID__in]
            }
        }
        if (args?.criteria?.accountStatus) {
            filters = {
                ...filters,
                deliveryStatus__in:
                    [args?.criteria?.accountStatus]
            }
        }
        try {
            if (client) {
                const res = await client.query({
                    query: GET_BOXES,
                    variables: {
                        filters: filters,
                        // filter: filter,
                        options: {
                            limit: args?.size ?? 9,
                            skip: args?.offset ?? 0,
                        }
                    },
                    fetchPolicy: "network-only",
                });
                // const res: any = sam_config;
                if (res?.data?.getAdptBoxes) {
                    log.success(
                        `gpt shelf data in GetBoxes screen :`,
                        storageService.get("bandConfig", "local")
                    );
                    let _templateData = this.formatShelfBoxes(
                        res?.data?.getAdptBoxes?.content
                    );

                    console.log(`row data`, _templateData);
                    let _totalPages = res?.data?.getAdptBoxes?.count
                        ? Math.ceil(parseInt(res?.data?.getAdptBoxes?.count) / 9)
                        : 1;

                    let _currentPage =
                        res?.data?.getAdptBoxes?.skip /
                        res?.data?.getAdptBoxes?.limit +
                        1;
                    return {
                        //logoSrc: "https://i.ibb.co/y5kGMjy/store-1.png",
                        boxes: res?.data?.getAdptBoxes?.content,
                        appCardList: _templateData,
                        isBoxEmpty: res?.data?.getAdptBoxes?.content?.length <= 0,
                        activePage: _currentPage,
                        totalCount: res?.data?.getAdptBoxes?.count,
                        pageSize: res?.data?.getAdptBoxes?.limit,
                        totalPages: _totalPages,
                        shelfBand:
                            storageService?.get("currencyExchangeLocal", "local")?.band ??
                            null,
                    };
                }
            }
        } catch (err: any) {
            console.log(`error in getBoxes`, err);
            return { isBoxEmpty: true };
            //return err;
        }
    }

    private formatShelfBoxes(data: any) {
        let _appCard: any =
            Array.isArray(data) &&
            data.map((item: any) => {
                return {
                    id: item?.id,
                    appCardId: item?.masqID,
                    appCardImage: item?.user?.image,
                    appCardTitle: item?.user?.fullName ? item?.user?.fullName : "Null Null",
                    //appCardDescription: `${_data?.masqID} | ${_data?.costumeID}`,
                    appCardList: [
                        {
                            name: "Masq ID",
                            value: item?.masqID,
                        },
                        {
                            name: "Costume ID",
                            value: item?.costumeID,
                        },
                    ],
                };
            });

        return _appCard;
    }
}
